<template>
  <div @click.stop="phoneClick">
    <a-select
      class="phoneCode"
      ref="phoneCode"
      :value="form.phoneCode | disCountryCode"
      :dropdownMatchSelectWidth="false"
      :open="open"
      :getPopupContainer="getPopupContainer ?  getPopupContainer : () => $el"
      :dropdownClassName="'entry-phoneCode'"
    >
      <div slot="suffixIcon">
        <icon-font type="gb-icon-Down" :style="{ 'transform': open ? `rotate(180deg)` : '' }" style="transition: all 0.3s;"></icon-font>
      </div>
      <div
        slot="dropdownRender"
        style="overflow: auto; padding: 4px 0"
        :style="{minWidth: currentLang === 'zh_CN' ? '260px' : '400px'}"
      >
        <div style="display: flex; justify-content: center;width: 100%;margin: 8px 0;">
          <a-input :placeholder="$t('common_login_输入地区模糊查询')" style="width: 90%" v-model="searchCode" @change="onSearch" />
        </div>
        <RecycleScroller
          style="max-height: 256px; min-height: 32px; overflow:auto"
          :items="filterCodeList"
          :item-size="32"
          :buffer="100"
          :prop="{value: 'index', text: 'name' + currentLangList[currentLang]}"
          @selected="changeInternational"
          v-if="filterCodeList.length"
        >
          <template v-slot="{item}">
            <div style="display:flex;justify-content:space-between; width:100%;">
              <span style="width: calc(100% - 70px);white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item['name' + currentLangList[currentLang === 'ko_KR' ? 'en_US' : currentLang]]}}</span>
              <span style="margin-right:2px">+ {{item.phonecode}}</span>
            </div>
          </template>
        </RecycleScroller>
        <a-empty
          v-else
          :image-style="{
          height: '60px',
          }"
          :image="simpleImage"
        >
          <span slot="description"> {{$t('layouts.text.undefined')}} </span>
        </a-empty>
      </div>
    </a-select>
  </div>
</template>

<script>
import RecycleScroller from '@/components/VirtualScroll/RecycleScroller'
import { eventListener } from '@/utils/util'
import { mapState } from 'vuex'
import {
  PhoneCodeInterface // 区号
} from '@/api/sso/code'
import { Empty } from 'ant-design-vue'

export default {
    components: {
      RecycleScroller
    },
    props: {
      getPopupContainer: {
        type: Function
      }
    },
    data () {
      return {
        countryCodeList: [
          { name_zh: '中国大陆', name: 'CHINA', phonecode: '86' },
          { name_zh: '中国香港', name: 'HONG KONG', phonecode: '852' },
          { name_zh: '中国澳门', name: 'MACAO', phonecode: '853' },
          { name_zh: '中国台湾', name: 'TAIWAN', phonecode: '886' },
          { name_zh: '美国', name: 'UNITED STATES', phonecode: '1' },
          { name_zh: '澳大利亚', name: 'AUSTRALIA', phonecode: '61' },
          { name_zh: '英国', name: 'UNITED KINGDOM', phonecode: '44' }
        ],
        form: {
          phonrCode: 86
        },
        open: false,
        filterCodeList: [],
        currentLangList: {
          'en_US': '',
          'zh_CN': '_zh'
        },
        searchCode: undefined
      }
    },
    computed: {
      ...mapState({
        currentLang: state => state.app.lang
      })
    },
    watch: {
      open: {
        handler () {
          if (!this.open) {
            this.searchCode = ''
            this.onSearch()
          }
        }
      }
    },
    methods: {
      phoneClick () {
        this.open = !this.open
      },
      changeInternational (val) {
        this.form.phoneCode = val.phonecode
        this.open = false
        this.$emit('changeCode', this.form.phoneCode)
      },
      onSearch () {
        this.filterCodeList = this.countryCodeList.filter(item => {
          return item.name_zh.indexOf(this.searchCode) !== -1 || item.name.indexOf(this.searchCode.toUpperCase()) !== -1 || item.phonecode.indexOf(Number(this.searchCode)) !== -1
        })
      },
      findNodeTree (data, findFunc = () => {}, props = { children: 'parentNode' }) {
        if (findFunc(data)) {
          return data
        } else if (data[props.children]) {
          return this.findNodeTree(data['parentNode'], findFunc, props)
        } else {
          return null
        }
      }
    },
    filters: {
      disCountryCode (val) {
        return `+ ${val}`
      }
    },
    async mounted () {
      await PhoneCodeInterface({}).then(({ data }) => { // 区号
        this.countryCodeList = JSON.parse(data.result).map((item, index) => ({ ...item, index }))
      }).finally(() => {
        this.form.phoneCode = this.countryCodeList[0].phonecode
      })
      this.filterCodeList = JSON.parse(JSON.stringify(this.countryCodeList))
      // 点击事件监听
      const func = (e) => {
      const found = this.findNodeTree(e.target, item => {
        const flag = item['classList'] ? item['classList'].contains('entry-phoneCode') : false
        return flag
      })
      if (!found) {
        this.open = Boolean(found)
      }
      }
      eventListener.call(this, 'click', func, null, {
        element: document.body,
        hook: 'beforeDestroy'
      })
    },
    beforeCreate () {
      this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
    }
}
</script>

<style lang="less" scoped>
  .ant-select.ant-select-open /deep/.ant-select-arrow-icon svg {
    transform: none;
  }
  .home-ant-select.home-ant-select-open /deep/.home-ant-select-arrow-icon svg {
    transform: none;
  }
  /deep/ .ant-select-selection-selected-value {
    max-width: 44px;
  }
   /deep/ .home-ant-select-selection-selected-value {
    max-width: 44px;
  }
</style>
